<template>
    <div class="container pt-5">
        <h1 class="pt-5">Latest Cars</h1>
        <CarList />

    </div>
</template>

<script>
import CarList from '../components/CarList'
export default {
  components: {
    CarList
  }
}
</script>

<style>

</style>
